import { createApp } from 'vue'
import App from './App.vue'
import router from '@/router/index'
import { createPinia } from 'pinia'
import './permission'
import 'virtual:svg-icons-register'
import ElementPlus from 'element-plus'
import './assets/styles/base.scss'

import * as ElementPlusIconsVue from '@element-plus/icons-vue'
// 导入IconPark样式
import '@icon-park/vue-next/styles/index.css'

const app = createApp(App)

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(createPinia())
app.use(ElementPlus)
app.use(router)

app.mount('#app')
